<template>
    <div class="gwms-tags-view-container" id="gwms-tags-view-container">
        <div ref="scrollPane" class="tags-view-wrapper">
            <div class="all-tags-inner" v-if="isShowTabs">
                <router-link v-for="tag in visitedViews.slice(0, numberCanBeShow)" ref="tag" :class="isActive(tag)?'active':''"
                    :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }" :key="tag.fullPath" tag="span"
                    class="tags-view-item-all" @click.middle.native="closeSelectedTag(tag)"
                    @contextmenu.prevent.native="openMenu(tag,$event)">
                    <el-tooltip :content="getTranslate(tag)"
                        placement="bottom" :disabled="tag.ellipsis">
                        <span class="tags-view-item">
                            <span class="tags-view-item-content">
                                {{getTranslate(tag)}}
                                {{tag.orderNo}}
                            </span>
                            <span class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
                        </span>
                    </el-tooltip>
                </router-link>
                <el-dropdown trigger="click" class="more-dropdown" v-if="visitedViews.length > numberCanBeShow">
                    <span class="el-dropdown-link">
                        {{$translate('component.E202011270001', { defaultText: '更多' })}}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                        <!-- $t('components.tagsNav.allTags') -->
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, index) in allTags" :key="index" @click.native="handleCloseAll(item, index)" class="tag-item">
                            {{getTranslate(item)}}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <ul v-show="visible" :style="{left:left+'px'}" class="contextmenu">
                <li @click="refreshSelectedTag(selectedTag)">{{ $translate('component.E202006152491', { defaultText: '刷新' }) }}</li>
                <li @click="closeSelectedTag(selectedTag)">{{ $translate('component.E202007300005', { defaultText: '关闭' }) }}</li>
                <li @click="closeOthersTags">{{ $translate('component.E202007300006', { defaultText: '关闭其他' }) }}</li>
                <li @click="closeAllTags">{{ $translate('component.E202007300007', { defaultText: '全部关闭' }) }}</li>
            </ul>
        </div>
        <div class="all-tags" ref="allTags">
            <div v-if="aliVertBtnVisible" class="ali-phone-vert">
               <el-button type="text" @click="openAliVertDialog">虚拟号码拨打人员实名认证链接</el-button>
            </div>

            <comp-toggle systemCode="headerOrg"><header-org v-if='hasHeaderOrg'></header-org></comp-toggle>
            <comp-toggle systemCode="earlyWarning"><msg-box v-if="showMessageTips" /></comp-toggle>
            <comp-toggle systemCode="userFileList ">
                <el-dropdown>
                    <i id="file-list" class="icon iconfont icon-gerenwenjian iconMDM-gerenwenjianliebiao file-list"></i>
                    <upload-list ref="uploadlist"></upload-list>
                </el-dropdown>
            </comp-toggle>
            <comp-toggle systemCode="languageChange">
                <Lang v-if="isShowLang" />
            </comp-toggle>
            <comp-toggle systemCode="appList">
                <App v-if="isShowApps" />
            </comp-toggle>
            <comp-toggle systemCode="train-enter"><Train-Enter v-if="isShowTrainEnter" :env="env" /></comp-toggle>
            <User :targetRoute="targetRoute">
                <el-dropdown-item name="tenant">
                    <tenant v-if="isShowTenant" />
                </el-dropdown-item>
                <a v-for="item in InfoList" :key='item.name' :href="item.url" target="_blank"
                    @click="bigDataRecord(item.bigDataKey)">
                    <el-dropdown-item :name="item.name">{{ item.name }}</el-dropdown-item>
                </a>
            </User>
        </div>
        <AliPhoneVertDialog ref="aliPhoneVertRef" @enableChange="val => aliVertBtnVisible = val"/>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import User from '@/components/core/themes/default/components/User.vue';
import headerOrg from '../header_org/Main';
import MsgBox from '../messageBox/Index';
import Utils from '@/utils/common';
import compToggle from '@/components/lots/compToggle';
import UploadList from '@/components/lots/OSS/UploadList.vue';
import Tenant from '../tenant/Tenant';
import Lang from '../lang/Index';
import Info from '../info/Index';
import App from '../app/Index';
import TrainEnter from '../train-enter/Index.js';
import Comment from '../comment/index';
import './main.js';
import { I18nMixins, _$t } from '@/components/utils/i18n';
import bigDataLog from '@/utils/bigDataLog';
import AliPhoneVertDialog from '@/components/lots/aliPhoneVertDialog/index.vue';
export default {
    mixins: [I18nMixins],
    components: {
        User,
        headerOrg,
        MsgBox,
        UploadList,
        Tenant,
        Lang,
        Info,
        App,
        compToggle,
        Comment,
        TrainEnter,
        AliPhoneVertDialog
    },
    props: {
        // 跳转用户个人中心的路由参数
        targetRoute: {
            type: String,
            default: '/user-center'
        },
        isShowLang: {
            type: Boolean,
            default: true
        },
        isShowTenant: {
            type: Boolean,
            default: true
        },
        isShowTabs: {
            type: Boolean,
            default: true
        },
        isShowApps: {
            type: Boolean,
            default: true
        },
        env: {
            type: String,
            default: ''
        },
        isShowTrainEnter: {
            type: Boolean,
            default: false
        },
        hasHeaderOrg: {
            type: Boolean,
            default: false
        },
        isShowInfo: {
            type: Boolean,
            default: true
        },
        hasUploadList: {
            type: Boolean,
            default: true
        },
        infoList: {
            type: Array
        },
        fixedInfoList: {
            type: Array
        },
        showMessageTips: {
            type: Boolean,
            default: true
        },
        AI_ROBOT_APP: {
            type: String,
            default: 'AI_ROBOT'
        },
        commentMonthly: { // 是否开启月评价
            type: Boolean,
            default: false
        },
        commentDaily: { // 是否开启日评价
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            left: 0,
            selectedTag: {},
            closeAllTag: [{ name: 'components.tagsView.closeAll', id: 'closeAll', meta: { title: this.$translate('component.E202007300007', { defaultText: '全部关闭' }) } }],
            allTags: [],
            warningList: [], // 预警列表
            warningType: ['', '消息', '预警'], // 预警类型
            noticeList: [], // 信息列表
            noticeType: ['', '公告', '预警', '维护', '更新'], // 信息类型
            msgDialogData: {}, // 信息弹窗数据
            warningListPage: 0,
            noticeListPage: 0,
            listPageSize: 10,
            warningListTotal: 0,
            noticeListTotal: 0,
            warningHasMore: true,
            noticeHasMore: true,
            warningScrollDisabled: true,
            noticeScrollDisabled: true,
            warningLoading: false,
            noticeLoading: false,
            numberCanBeShow: 0,
            flatResourceSearch: [],
            InfoList: [
                {
                    name: _$t('component.E1202104124669', { defaultText: '法律声明及隐私政策' }),
                    url: 'https://static.annto.com/res/webInfo/privacy.html',
                    bigDataKey: 'bigData-btn-header-bar-privacy'
                }, {
                    name: _$t('component.E1202104124670', { defaultText: '联系我们' }),
                    url: 'https://static.annto.com/res/webInfo/contact_us.html',
                    bigDataKey: 'bigData-btn-header-bar-contact'
                }, {
                    name: _$t('component.E1202104124671', { defaultText: '服务条款' }),
                    url: 'https://static.annto.com/res/webInfo/service.html',
                    bigDataKey: 'bigData-btn-header-bar-service'
                }
            ],
            aliVertBtnVisible: false
        };
    },
    computed: {
        ...mapGetters(['user', 'visitedViews', 'cachedViews', 'tenantInfo', 'authority'])
    },
    watch: {
        authority(val) {
            if (!val.length) { // 没有菜单权限tab栏关闭所有页面去到404页面
                this.closeAllTags();
            }
        },
        $route(val) {
            // 移动端上传日志
            if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
                if (this.prevRoutePath !== val.fullPath) {
                    this.prevRoutePath = val.fullPath;
                    window._paq && window._paq.push(['trackEvent', 'Enter', 'Mobile', this.prevRoutePath]);
                }
            }
            this.addViewTags();
            this.moveToCurrentTag();
        },
        visible(value) {
            if (value) {
                document.body.addEventListener('click', this.closeMenu);
            } else {
                document.body.removeEventListener('click', this.closeMenu);
            }
        }
    },
    mounted() {
        this.$eventBus.$on('closeTag', param => {
            this.closeSelectedTag(param);
        });
        this.addViewTags();
        const dbody = document.getElementById('gwms-tags-view-container');
        this.mousewheelTags(dbody);
        const widthCanBeUse = document.body.clientWidth -
            document.getElementsByClassName('all-tags')[0].offsetWidth - // all-tags的宽度
            200 - // 展开菜单的宽度
            30; // all-tags未渲染出的图标宽度
        const numberCanBeShow = parseInt((widthCanBeUse - 24 - 57) / 81, 10);
        this.numberCanBeShow = numberCanBeShow;
    },
    created() {
        const menu = this.authority;
        this.getFlatResource(menu);
    },
    methods: {
        bigDataRecord(key) {
            bigDataLog.sendDetailMessageByKey(key);
        },
        getTranslate(tag) {
            let content = null;
            const findTargetMenu = this.flatResourceSearch.find((item) => {
                return item.frontUrl === tag.path;
            });
            if (findTargetMenu) {
                content = this.$translate(`lang.${tag.resourceCode}`, { defaultText: tag.resourceName });
            } else {
                content = this.$t((tag.meta && tag.meta.title) || tag.name);
            }
            return content;
        },
        handleFileList() {
            this.$refs.uploadlist.visible = true;
        },
        isActive(route) {
            return route.fullPath.split('?')[0] === this.$route.fullPath.split('?')[0];
        },
        // 平铺的页面资源
        getFlatResource(resource, deep = 0) {
            for (let i = 0; i < resource.length; i++) {
                const PageType = 2;
                if (resource[i].resourceType === PageType) {
                    this.flatResourceSearch.push(resource[i]);
                }

                if (resource[i].subResources) {
                    if (resource[i].subResources.length >= 0) {
                        const nextDeep = deep + 1;
                        this.getFlatResource(resource[i].subResources, nextDeep);
                    }
                }
            }
        },
        addViewTags() {
            this.$emit('open-keep-alive');
            const { name } = this.$route;

            // 根据路径找到菜单信息
            let targetMenu = {};
            const findTargetMenu = this.flatResourceSearch.find((item) => {
                return item.frontUrl === this.$route.path;
            });
            targetMenu = findTargetMenu || {};
            // if (this.$route.fullPath === '/' || this.$route.fullPath === '/index') {
            //     targetMenu.resourceCode = 'appIndex';
            //     targetMenu.resourceName = '首页';
            // }

            // 这里就是'/'
            if (name === 'm') {
                this.$router.push('/index');
                return true;
            }
            const temp = this.visitedViews.some(item => {
                return item.name === name;
            });
            if (name) {
                this.$store.dispatch('addView', { ...targetMenu, ...this.$route });
                this.visitedViews.map(item => {
                    let realLength = 0;
                    let charCode = -1;
                    const str = this.getTranslate(item);
                    const len = str.length;
                    for (let i = 0; i < len; i++) {
                        charCode = str.charCodeAt(i);
                        if (charCode >= 0 && charCode <= 128) realLength += 1;
                        else realLength += 2;
                    }
                    if (realLength > 10) {
                        item.ellipsis = false;
                    } else {
                        item.ellipsis = true;
                    }
                });
                if (this.visitedViews.length > this.numberCanBeShow && !temp) {
                    let tempArr = [];
                    tempArr = Utils.ArrMove(this.visitedViews, this.visitedViews.length - 1, this.numberCanBeShow);
                    tempArr = Utils.ArrMove(tempArr, 0, tempArr.length - 1);
                    this.COVER_VISITED_VIEW(tempArr);
                    this.allTags = this.closeAllTag.concat(this.visitedViews.slice(this.numberCanBeShow));
                    // this.$router.push({ path: item.path, query: item.query, fullPath: item.fullPath });
                }
            }
            this.allTags = this.closeAllTag.concat(this.$store.getters.visitedViews.slice(this.numberCanBeShow));
            return false;
        },
        moveToCurrentTag() {
            const tags = this.$refs.tag;
            this.$nextTick(() => {
                if (!tags) {
                    return;
                }
                for (const tag of tags) {
                    if (tag.to.fullPath === this.$route.fullPath) {
                        break;
                    }
                }
            });
        },
        refreshSelectedTag(view) {
            this.$store.dispatch('delCachedView', view).then(() => {
                const { fullPath } = view;
                this.$nextTick(() => {
                    this.$router.replace({
                        path: '/redirect' + fullPath
                    });
                });
            });
        },
        handleDestroyed(router) {
            const { path, matched } = router;
            let matchedRouter;
            if (matched) {
                matchedRouter = matched.find(item => {
                    return item.path === path;
                });
            }
            if (matchedRouter) {
                const { destroyPage } = matchedRouter.components.default;
                destroyPage && destroyPage.call(matchedRouter.instances.default);
            }
        },
        closeTagHandler(view) {
            this.handleDestroyed(view);
            this.$emit('refresh-keep-alive', view);
            this.$store.dispatch('delView', view).then(({ visitedViews }) => {
                if (this.isActive(view)) {
                    const latestView = visitedViews.slice(-1)[0];
                    if (latestView) {
                        this.$router.push(latestView);
                    } else {
                        this.$router.push('/index');
                    }
                }
                this.allTags = this.closeAllTag.concat(visitedViews.slice(this.numberCanBeShow));
            });
        },
        closeSelectedTag(view) {
            this.$eventBus.$off('tabViewClose');
            this.$eventBus.$on('tabViewClose', view => {
                if (view && view.meta.takeOverTagClose) {
                    this.closeTagHandler(view);
                }
            });
            this.$eventBus.$emit(view.name, view);
            if (view.meta.takeOverTagClose) return;
            this.closeTagHandler(view);
        },
        closeOthersTags() {
            this.$router.push(this.selectedTag);
            this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
                this.moveToCurrentTag();
            });
        },
        closeAllTags() {
            this.$store.dispatch('delAllViews');
            this.$router.push('/index');
        },
        openMenu(tag, e) {
            const menuMinWidth = 105;
            if (!this.$el) return;
            const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
            const offsetWidth = this.$el.offsetWidth; // container width
            const maxLeft = offsetWidth - menuMinWidth; // left boundary
            const left = e.clientX - offsetLeft + 15; // 15: margin right

            if (left > maxLeft) {
                this.left = maxLeft;
            } else {
                this.left = left;
            }

            this.visible = true;
            this.selectedTag = tag;
        },
        closeMenu() {
            this.visible = false;
        },
        handleCloseAll(item, index) {
            if (item.id && item.id === 'closeAll') {
                this.closeAllTags();
                this.$emit('refresh-keep-alive', 'closeAll');
            } else {
                let tempArr = [];
                tempArr = Utils.ArrMove(this.visitedViews, this.visitedViews.length - 1, this.numberCanBeShow);
                tempArr = Utils.ArrMove(tempArr, 0, tempArr.length - 1);
                this.COVER_VISITED_VIEW(tempArr);
                this.allTags = this.closeAllTag.concat(this.visitedViews.slice(this.numberCanBeShow));
                this.$router.push({ path: item.path, query: item.query, fullPath: item.fullPath });
            }
        },
        mousewheelTags(dbody) {
            // ff用
            this.objAddEvent(dbody, 'DOMMouseScroll', (e) => {
                return this.mouseScroll(e, dbody);
            });
            // 非ff chrome 用
            this.objAddEvent(dbody, 'mousewheel', (e) => {
                return this.mouseScroll(e, dbody);
            });
            // chrome用
            this.objAddEvent(dbody, 'mousewheel', (e) => {
                return this.mouseScroll(e, dbody);
            });
        },
        // 这个是给对象增加监控方法的函数
        objAddEvent(oEle, sEventName, fnHandler) {
            if (oEle.attachEvent) {
                oEle.attachEvent('on' + sEventName, fnHandler);
            } else {
                oEle.addEventListener(sEventName, fnHandler, true);
            }
        },
        mouseScroll(e, dbody) {
            e = e || window.event;
            e.stopPropagation();
            e.preventDefault();
            const delD = e.wheelDelta ? e.wheelDelta : -e.deltaX * 40; // 判断上下方向
            const moves = delD > 0 ? -50 : 50;
            dbody.scrollLeft += moves; // 非chrome浏览器用这个
            // chrome浏览器用这个
            if (dbody.scrollLeft === 0) {
                dbody.scrollLeft += moves;
            }
            return false;
        },
        // 打开阿里虚拟号码认证链接
        openAliVertDialog() {
            if (this.$refs.aliPhoneVertRef) {
                this.$refs.aliPhoneVertRef.show();
            }
        },

        ...mapMutations({
            COVER_VISITED_VIEW: 'COVER_VISITED_VIEW'
        })
    }
};

</script>

<style lang="less">
.gwms-tags-view-container {
    flex: 0 0 40px;
    display: flex;
    width: 100%;
    height: 40px;
    background: #fff;
    color: #999;
    overflow: hidden;

    .contextmenu {
        margin: 0;
        background: #fff;
        z-index: 100;
        top: 40px;
        position: absolute;
        list-style-type: none;
        line-height: 1.5em;
        padding: 5px 0;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color: #333;
        box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);

        li {
            margin: 0;
            padding: 7px 16px;
            cursor: pointer;

            &:hover {
                background: #eee;
            }
        }
    }

    .tags-view-item-all {
        cursor: pointer;
        height: 100%;
        line-height: 40px;
        padding: 0 8px;
        font-size: 12px;

        .tags-view-item {
            .el-icon-close {
                margin-left: 10px;
                color: #999;
                display: none;
            }
        }

        .tags-view-item-content {
            max-width: 65px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: table-cell;
        }

        &:hover {
            background-color: #fafafa;
            color: #666;

            .el-icon-close {
                margin-left: 10px;
                color: #999;
                display: inline-block;
            }
        }

        &.active {
            background-color: #f5f5f5;
            color: #333;

            &:after {
                content: none;
            }

            .el-icon-close {
                margin-left: 10px;
                color: #999;
                display: inline-block;
            }
        }

    }

    .tags-view-item-all.active {
        .el-icon-close:hover {
            background-color: rgba(255, 255, 255, 0.9);
            color: #00bcbf;
        }

        .tags-view-item {
            border: none;
        }
    }

    .more-dropdown {
        line-height: 40px;
        padding: 0 8px;
        cursor: pointer;
    }

    .el-icon-close {
        width: 12px;
        height: 12px;
        line-height: 12px;
        border-radius: 50%;
        text-align: center;
        transition: all .3s cubic-bezier(.645, .045, .355, 1);
        transform-origin: 100% 50%;

        &:before {
            transform: scale(.6);
            display: inline-block;
            vertical-align: -2px;
            text-align: center;
            font-size: 18px;
            margin-left: -3px;
        }

        &:hover {
            background-color: #b4bccc;
            color: #fff;
        }
    }

    .tags-view-wrapper {
        flex: 1;
        overflow-x: auto;
        overflow-y: hidden;

        .all-tags-inner {
            height: 100%;
            overflow: visible;
            white-space: nowrap;
            display: flex;
            justify-content: flex-start;
            align-content: center;
        }
    }

    .all-tags {
        line-height: 40px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .file-list {
            cursor: pointer;
            margin-right: 20px;
            font-size: 20px;
            vertical-align: middle;
        }
    }

    .ali-phone-vert {
        margin-right: 20px;
        .el-button--text {
            color: #444;
            &:hover {
                color: #00BCBF;
            }
        }
    }
}

.el-dropdown-menu {
    max-height: 400px;
    overflow: auto;

    a:first-child {
        .tag-item {
            color: #00BCBF;
            font-weight: bold;
        }
    }
}
</style>
